// extracted by mini-css-extract-plugin
export default {"icon":"policyHolderClaimReviewAcceptedRejectedWordings_icon__V2jv2","accepted-wordings":"policyHolderClaimReviewAcceptedRejectedWordings_accepted-wordings__FDFfT"};